/**
 * InviteSendButton component
 * Send invitations button
 */

import React from 'react';
import { Text, Pressable, Platform, ActivityIndicator } from 'react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { useInviteModalStyles } from '../../../src/friends/contexts/InviteModalStylesContext';
import { getSendButtonText } from '../../../src/friends/helpers/inviteModal.helper';

interface InviteSendButtonProps {
  selectedCount: number;
  sendingInvites: boolean;
  onSend: () => void;
  testID?: string;
}

export const InviteSendButton: React.FC<InviteSendButtonProps> = ({
  selectedCount,
  sendingInvites,
  onSend,
  testID,
}) => {
  const styles = useInviteModalStyles();
  if (selectedCount === 0) return null;

  return (
    <Pressable
      onPress={onSend}
      disabled={sendingInvites}
      style={({ pressed, hovered }) => [
        styles.sendButton,
        sendingInvites && styles.sendButtonDisabled,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        !sendingInvites && pressed && styles.sendButtonPressed,
        !sendingInvites && hovered && Platform.OS === 'web' && styles.sendButtonHover,
      ]}
      testID={testID || 'invite-send-button'}
    >
      {sendingInvites ? (
        <ActivityIndicator color="white" />
      ) : (
        <Text style={styles.sendButtonText}>
          {getSendButtonText(selectedCount)}
        </Text>
      )}
    </Pressable>
  );
};
